export default {
    state: {
      loops: {
        liveFeed: 0,
      },
      errors: {},
      promoCodes: [],
      transactions: [],
      courses: [],
      blockTypes: {
        'banner': 'Banner',
        'bio': 'Bio',
        'button': 'Button',
        'lecture-list': 'Lecture list',
        'course-list': 'Course list',
        'html': 'HTML',
        'text': 'Text',
        'quote': 'Quote',
        'checklist': 'Checklist',
        'side-image': 'Side image',
        'gallery': 'Gallery',
        'columns': 'Columns',
        'image': 'Image',
        'faq': 'FAQ',
        'lead-generation': 'Lead generation',
        'video': 'Video',
        'video-embed': 'Video embed',
        'countdown-time': 'Countdown (time)',
      },
    },
    mutations: {
      updateLoops(state, payload) {
        state.loops = {...state.loops, ...payload}
      },
      updateErrors(state, payload) {
        state.errors = payload
      },
      promoCodesUpdate(state, payload) {
        state.promoCodes = payload
      },
      promoCodeUpdate(state, payload) {
        const item = state.promoCodes.find(item => item.id === payload.id)
        Object.assign(item, payload)
      },
      coursesUpdate(state, payload) {
        state.courses = payload
      },
      transactionsUpdate(state, payload) {
        state.transactions = payload
      },
    },
  }
  